import { UserOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Avatar, Dropdown, Flex, Space } from "antd";
import type { MenuProps } from "antd";
import { userQueries } from "@/entities/user";
import logoBlackTextIcon from "@shared/assets/svg/icons/logo-black-text-icon.png";
import logoBlueIcon from "@shared/assets/svg/icons/logo-blue-icon.png";
import { env } from "@shared/config.ts";
import { useRedirect } from "@shared/lib/hooks";
import { useNavigate, routes } from "@shared/lib/react-router";
import { TabsMenu } from "./tabs-menu";
import "./header.scss";

export const UserHeader = () => {
  const { data: user } = useQuery(userQueries.currentUser());
  const redirect = useRedirect();
  const navigate = useNavigate();

  const logout = () => {
    redirect(`${env.OLD_FRONTEND_URL}/logout?redirectTo=${env.FRONTEND_URL}`);
  };

  const handleLogoClick = () => {
    navigate("/projects");
  };

  const items: MenuProps["items"] = [
    {
      key: 1,
      label: "Профиль",
      onClick: () => navigate(routes.profile()),
    },
    {
      key: 3,
      label: "Выйти",
      onClick: logout,
    },
  ];

  return (
    <header className="header-container">
      <div className="header-logo" onClick={handleLogoClick}>
        {/* <img
          src="https://builddocs.online/assets/img/logo.svg"
          alt="на главную"
        /> */}
        <img
          className="header-logo__icon"
          src={logoBlueIcon}
          width={24}
          height={24}
          alt="logo"
        />
        <img src={logoBlackTextIcon} width={100} height={14} alt="logo" />

        {/* <BlackLogoTextIcon /> */}
      </div>
      {env.CURRENT_ENV_MODE !== "production" && (
        <p className="absolute-version">
          2.0 - api preview {env.CURRENT_ENV_MODE}
        </p>
      )}

      <TabsMenu className="header-tabs" />

      <Flex className="header-user-menu">
        <Dropdown
          menu={{ items }}
        >
          <Flex onClick={(e) => e.preventDefault()}>
            <Space>
              <Flex vertical className="header-user-info">
                <p className="header-user-name">
                  {user?.firstName} {user?.lastName}
                </p>
                <p className="header-user-position">
                  {user?.employment?.position.description}
                </p>
              </Flex>
              <Avatar size={28} icon={<UserOutlined />} />
            </Space>
          </Flex>
        </Dropdown>
      </Flex>
    </header>
  );
};
